import Vuex from "vuex";
import Vue from "vue";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: {
      token: "",
      name: "",
      di: "",
      phone: "",
      email: ""
    },
    urltest: "https://api2.notariavilca.org",
    url: "https://api.notariavilca.org",
    login: false,
    token: "", // The TV inventory
    tramites: [
      {
        id: 0,
        name: "Legalizaciones",
        resumen:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus nec iaculis mauris.",
        tipos: [
          {
            id: 0,
            name: "Legalizaciones de Firmas",
            resumen:
              "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus nec iaculis mauris.",
            requirements: {
              name: "Requisitos para legalizacion de firmas",
              puntos: [
                "El documento original que se pretende legalizar",
                "Documento de identidad (DNI, Carné de extranjería, etc.). El documento de identidad no debe tener multas.",
                "Si la legalizacion es con poder es necesario una vigencia de poder expedida por los Registros Publicos con una antiguedad menor a 30 dias."
              ]
            }
          }
        ]
      }
    ]
  },

  getters: {
    // Here we will create a getter
  },

  mutations: {
    setUser(state, user) {
      (state.login = true), (state.user = user);
    },
    setTramites(state, tramites) {
      state.tramites = tramites;
    }
    // Here we will create Jenny
  },
  
  actions: {
    // Here we will create Larry
    loadUser(contex) {
      let user = sessionStorage.getItem("user", null);
      if (user != null) {
        contex.commit("setUser", JSON.parse(user));
      }
    },
    setUser(context, user) {
      context.commit("setUser", user);
      sessionStorage.setItem("user", JSON.stringify(user));
    },
    setTramites(context, tramites) {
      context.commit("setTramites", tramites);
    }
  }
});
